/**
 * 模板配置前端接口
 */

import { request } from '@/utils/http'
import {
  type BatchDeleteRequest,
  type PageResponse
} from '@/api/types/common'

// API基础路径
const API_BASE = '/sys/template'

// ==================== 模板相关模型 ====================

/**
 * 模板VO模型
 */
export interface TemplateVO {
  /** 唯一标识 */
  id?: string | null
  /** 租户ID */
  tenantId?: string | null
  /** 创建人 */
  createdBy?: string | null
  /** 创建时间 */
  dateCreated?: string | null
  /** 修改人 */
  modifiedBy?: string | null
  /** 修改时间 */
  dateModified?: string | null
  /** 模板编号 */
  templateNo?: string | null
  /** 模版中文名 */
  name?: string | null
  /** 模版英文名 */
  nameEn?: string | null
  /** 公司ID */
  officeId?: string | null
  /** 云储存ID */
  documentId?: string | null
  /** 模版类型 */
  templateType?: string | null
  /** 模板用途 0-打印 1-邮件 */
  templateUsage?: number | null
  /** 备注 */
  remarks?: string | null
  /** 数据源大类 */
  schemaType?: string | null
}

/**
 * 模板查询请求参数
 */
export interface TemplateQueryRequest {
  /** 当前页码，默认为1 */
  pageNum?: number | null
  /** 每页大小，默认为10 */
  pageSize?: number | null
  /** 唯一标识 */
  id?: string | null
  /** 模板名称 */
  name?: string | null
  /** 模板编号 */
  templateNo?: string | null
  /** 云存储ID */
  documentId?: string | null
  /** 公司ID */
  officeId?: string | null
  /** 模板类型 */
  templateType?: string | null
  /** 模板用途 0-打印 1-邮件 */
  templateUsage?: number | null
}

/**
 * 模板保存请求参数
 */
export interface TemplateSaveRequest extends TemplateVO {
}

// ==================== 模板类型相关模型 ====================

/**
 * 模板类型VO模型
 */
export interface TemplateTypeVO {
  /** 唯一标识 */
  id?: string | null
  /** 租户ID */
  tenantId?: string | null
  /** 创建人 */
  createdBy?: string | null
  /** 创建时间 */
  dateCreated?: string | null
  /** 修改人 */
  modifiedBy?: string | null
  /** 修改时间 */
  dateModified?: string | null
  /** 数据源大类 */
  schemaType?: string | null
  /** 模板类 */
  templateType?: string | null
  /** 模板类型说明 */
  templateTypeDesc?: string | null
  /** 备注 */
  remarks?: string | null
}

/**
 * 模板类型查询请求参数
 */
export interface TemplateTypeQueryRequest {
  /** 当前页码，默认为1 */
  pageNum?: number | null
  /** 每页大小，默认为10 */
  pageSize?: number | null
  /** 唯一标识 */
  id?: string | null
  /** 数据源大类 */
  schemaType?: string | null
  /** 模板类 */
  templateType?: string | null
  /** 模板类型说明 */
  templateTypeDesc?: string | null
}

/**
 * 模板类型保存请求参数
 */
export interface TemplateTypeSaveRequest extends TemplateTypeVO {
}

// ==================== 模板相关API ====================

/**
 * 分页查询模板列表
 */
export const pageTemplate = (params: TemplateQueryRequest) => {
  return request.post<PageResponse<TemplateVO>>(`${API_BASE}/page`, params)
}

/**
 * 查询模板列表
 */
export const listTemplate = (params: TemplateQueryRequest) => {
  return request.post<TemplateVO[]>(`${API_BASE}/list`, params)
}

/**
 * 根据ID获取模板详情
 */
export const getTemplateById = (id: string) => {
  return request.post<TemplateVO>(`${API_BASE}/getById`, { id })
}

/**
 * 新增模板
 */
export const saveTemplate = (params: TemplateSaveRequest) => {
  return request.post<boolean>(`${API_BASE}/save`, params)
}

/**
 * 更新模板
 */
export const updateTemplate = (params: TemplateSaveRequest) => {
  return request.post<boolean>(`${API_BASE}/update`, params)
}

/**
 * 删除模板
 */
export const deleteTemplate = (id: string) => {
  return request.post<boolean>(`${API_BASE}/delete`, { id })
}

/**
 * 批量删除模板
 */
export const batchDeleteTemplate = (params: BatchDeleteRequest) => {
  return request.post<boolean>(`${API_BASE}/batchDelete`, params)
}

// ==================== 模板类型相关API ====================

/**
 * 分页查询模板类型列表
 */
export const pageTemplateType = (params: TemplateTypeQueryRequest) => {
  return request.post<PageResponse<TemplateTypeVO>>(`${API_BASE}/type/page`, params)
}

/**
 * 查询模板类型列表
 */
export const listTemplateType = (params: TemplateTypeQueryRequest) => {
  return request.post<TemplateTypeVO[]>(`${API_BASE}/type/list`, params)
}

/**
 * 根据ID获取模板类型详情
 */
export const getTemplateTypeById = (id: string) => {
  return request.post<TemplateTypeVO>(`${API_BASE}/type/getById`, { id })
}

/**
 * 新增模板类型
 */
export const saveTemplateType = (params: TemplateTypeSaveRequest) => {
  return request.post<boolean>(`${API_BASE}/type/save`, params)
}

/**
 * 更新模板类型
 */
export const updateTemplateType = (params: TemplateTypeSaveRequest) => {
  return request.post<boolean>(`${API_BASE}/type/update`, params)
}

/**
 * 删除模板类型
 */
export const deleteTemplateType = (id: string) => {
  return request.post<boolean>(`${API_BASE}/type/delete`, { id })
}

/**
 * 批量删除模板类型
 */
export const batchDeleteTemplateType = (params: BatchDeleteRequest) => {
  return request.post<boolean>(`${API_BASE}/type/batchDelete`, params)
}
